module.exports = __webpack_public_path__ + "static/media/six.a9827a6b.svg";